import getApiClient from '@/plugins/api-client'

export default {
  sendFeedback: function () {
    const self = this
    self.$store.state.loading = true

    self.errors = {
      professionalFeedback: null,
    }

    const api = getApiClient(self.$store)

    api.patch(`${self.job['@id']}/feedback`, {
      professionalFeedback: self.professionalFeedback
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .then(result => {
        self.$emit('feedbackSent', result.data)
        self.showSuccessMessage('Feedback enviado!')
      })
      .catch(error => {
        let response = error.response
        switch (response.status) {
          case 400:
          case 422:
            if (error.response.data.violations) {
              error.response.data.violations.forEach((violation) => {
                self.errors[violation.propertyPath] = violation.message
              })
            }
            break;
          default:
            self.showErrorMessage('Ocorreu um erro ao enviar seu feedback')
            break;
        }
      })
      .finally(() => {
        self.$store.state.loading = false
      })
  },

  showErrorMessage: function (message) {
    const self = this

    self.errorMessage.content = message
    self.errorMessage.show = true
  },

  showSuccessMessage: function (message) {
    const self = this

    self.successMessage.content = message
    self.successMessage.show = true
  },
}
